import {
  SET_EDIT_MENU_ITEMS,
  SET_MASS_TEXT_ICON_DISABLED,
  SET_MASS_TEXT_TOGGLE_DISABLED,
  SET_NOTIFICATION_VALUE
} from './tool-bar-mutation-types'
export const toolBar = {
  namespaced: true,
  state: {
    editMenuItems: [],
    massTextIcon: {
      disabled: true,
      toggleDisabled: false
    },
    notificationOn: false
  },
  getters: {
    getEditMenuItems: (state) => {
      return state.editMenuItems
    },
    getMassTextIcon: (state) => {
      return state.massTextIcon
    },
    getMassTextIconDisabled: (state) => {
      return state.massTextIcon.disabled
    },
    isNotificationOn: (state) => {
      return state.notificationOn
    }
  },
  actions: {
    setEditMenuItems ({ commit }, { val }) {
      commit(SET_EDIT_MENU_ITEMS, { val })
    },
    setMassTextIconDisabled ({ commit }, { val }) {
      commit(SET_MASS_TEXT_ICON_DISABLED, { val })
    },
    setMassTextToggleDisabled ({ commit }, { val }) {
      commit(SET_MASS_TEXT_TOGGLE_DISABLED, { val })
    },
    setNotificationValue ({ commit }, { val }) {
      commit(SET_NOTIFICATION_VALUE, { val })
    }
  },
  mutations: {
    [SET_EDIT_MENU_ITEMS] (state, { val }) {
      state.editMenuItems = val
    },
    [SET_MASS_TEXT_ICON_DISABLED] (state, { val }) {
      state.massTextIcon.disabled = val
    },
    [SET_MASS_TEXT_TOGGLE_DISABLED] (state, { val }) {
      state.massTextIcon.toggleDisabled = val
    },
    [SET_NOTIFICATION_VALUE] (state, { val }) {
      state.notificationOn = val
    }
  }
}
